import { createSlice } from "@reduxjs/toolkit";
import { getAllNoticeSrcImagesAction, organizationNoticeSectionAction, organizationNoticeTemplateAction, saveNoticeSectionAction } from "../../actions/NoticeTemplate/noticeTemplateAction";


const noticeTemplateSlice = createSlice({
  name: "noticeTemplate",
  initialState: {
    allOrganizationNotices: [],
    individualorganizationNotice: null,
    userImages:[],
    loading: false,
    error: null,
    savedSection: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
     .addCase(organizationNoticeSectionAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(organizationNoticeSectionAction.fulfilled, (state, { payload }) => {
       
        state.loading = false;
        state.allOrganizationNotices = payload.data;
      })
      .addCase(organizationNoticeSectionAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(organizationNoticeTemplateAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(organizationNoticeTemplateAction.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.individualorganizationNotice = payload.data;
      })
      .addCase(organizationNoticeTemplateAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveNoticeSectionAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNoticeSectionAction.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.savedSection = payload.data;
      })
      .addCase(saveNoticeSectionAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
//notice src img
       .addCase(getAllNoticeSrcImagesAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllNoticeSrcImagesAction.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.userImages = payload.data?.data ??[];
      })
      .addCase(getAllNoticeSrcImagesAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});



export default noticeTemplateSlice.reducer;
